import styled from "styled-components";
import {
  BASE_COLORS,
  FONT_FAMILY,
  FONT_WEIGHT,
  FONT_SIZE_PX,
} from "config/theme/constants";

export const TableWrapper = styled.div`
  .ant-table-wrapper .ant-table.ant-table-small {
    font-size: ${FONT_SIZE_PX.xs};
    font-family: ${FONT_FAMILY.main};
    opacity: 100%;
  }

  .ant-table-thead .ant-table-cell {
    background-color: ${BASE_COLORS.curiousBlue};
    color: ${BASE_COLORS.white};
  }

  .ant-table-wrapper .ant-table-thead > tr > th {
    font-weight: ${FONT_WEIGHT.regular};
  }

  .ant-table-wrapper .ant-table-thead th.ant-table-column-sort {
    background-color: ${BASE_COLORS.curiousBlue};
    color: ${BASE_COLORS.white};
  }

  .ant-table-wrapper .ant-table-thead th.ant-table-column-has-sorters:hover {
    background-color: ${BASE_COLORS.curiousBlue};
    color: ${BASE_COLORS.white};
  }

  .ant-table-wrapper .ant-table-column-sorter-down.active,
  .ant-table-wrapper .ant-table-column-sorter-up.active {
    color: ${BASE_COLORS.white};
  }

  .ant-table-wrapper .ant-table-column-sorter,
  .ant-table-wrapper .ant-table-column-sorter:hover {
    color: ${BASE_COLORS.periwinkle} !important;
  }

  .ant-table-wrapper .ant-table.ant-table-small .ant-table-thead > tr > th {
    padding: 10px 10px;
  }

  .ant-table-wrapper
    .ant-table-container
    table
    > thead
    > tr:first-child
    > *:last-child {
    border-start-end-radius: 0px;
  }

  .ant-table-wrapper
    .ant-table-container
    table
    > thead
    > tr:first-child
    > *:first-child {
    border-start-start-radius: 0px;
  }

  .ant-pagination .ant-pagination-item-active {
    line-height: 22px;
    border-radius: 15px;
    border-color: ${BASE_COLORS.curiousBlue};
    background: ${BASE_COLORS.curiousBlue};
    font-size: ${FONT_SIZE_PX.xs};
  }

  .ant-pagination {
    font-size: ${FONT_SIZE_PX.xs};
    font-weight: ${FONT_WEIGHT.normal};
  }

  .ant-pagination .ant-pagination-item-active a {
    color: ${BASE_COLORS.white};
    opacity: 100%;
    font-weight: ${FONT_WEIGHT.normal};
  }

  .ant-pagination.ant-pagination-mini:not(.ant-pagination-disabled)
    .ant-pagination-item:not(.ant-pagination-item-active):hover {
    border-radius: 15px;
  }

  .ant-table-wrapper .ant-table.ant-table-small {
    font-size: ${FONT_SIZE_PX.xs};
  }

  .ant-pagination-options {
    position: absolute;
    left: 0;
  }

  .ant-pagination-total-text {
    position: absolute;
    left: 62px;
  }

  .ant-table-wrapper
    .ant-table.ant-table-small
    .ant-table-tbody
    > tr
    > td:last-child {
    text-align: center;
  }

  @media only screen and (max-width: 576px) {
    .ant-pagination .ant-pagination-options {
      display: block;
    }
  }
`;
